import { render, staticRenderFns } from "./ProductBundleOptions.vue?vue&type=template&id=685215ef&scoped=true&"
import script from "./ProductBundleOptions.vue?vue&type=script&lang=js&"
export * from "./ProductBundleOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685215ef",
  null
  
)

export default component.exports